@if(isVisible){
    <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div class="bg-white rounded-lg shadow-md p-6 w-96">
          <div class="text-xl font-bold mb-4 text-gray-800">{{ header }}</div>
          <div class="text-gray-600 mb-6">{{ message }}</div>
          <div class="flex justify-end space-x-4">
            <button
              class="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
              (click)="cancel()"
            >
              Cancel
            </button>
            <button
              class="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              (click)="confirm()"
            >
              Okay
            </button>
          </div>
        </div>
      </div>
}
